import React, { useEffect, useState } from "react";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { Btn } from "../../AbstractElements";
import {
  useAllPositionList,
  useDayLockedListData,
  useDayLockedListDataByID,
  useGetDesignationsData,
  useGetEmployeeStatusData,
  useGetGradeMastersData,
  useGetOrgUnitsData,
  useReleaseDayLocked,
} from "./hooks/useEmployee";
import { Input, Label, Spinner } from "reactstrap";
import { showToast } from "../../utils/toastUtils";
import { getAllPositionList } from "./hooks/EmployeeRepository";
import CustomDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdownPagination";
import { useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import CustomInput from "../../Component/BasicComponents/CustomInput";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { COLORS } from "../../constants/colors";

type Props = {};



const DayLockedModal = ({ selectedRow, toggle }: any) => {
  const [selectedDate, setSelectedDate] = useState<string[]>([]);
  const [remark, setRemark] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const queryClient = useQueryClient();

  const { data: DayLockedListDates ,isLoading} = useDayLockedListDataByID({
    enable: true,
    params: {
      employeeId: selectedRow?.EmployeeId,
    },
  });

  const { mutate: DayRelease, isPending: isSubmit } = useReleaseDayLocked();

  

  const uniqueDayLockedDates =
    Array.from(
      new Map(
        DayLockedListDates?.data?.map((d: any) => [d.AttendanceDate, d])
      ).values()
    ) || [];

  const allDates = uniqueDayLockedDates.map((d: any) => d.AttendanceDate) || [];
  const isAllSelected =
    selectedDate.length === allDates.length && allDates.length > 0;

  // 👉 Detect if user selected ALL or just a subset




  // useEffect(() => {
  //   console.log(" allDates:", allDates);
  //   console.log("Selected dates:", selectedDate);
  //   console.log("Is all selected:", isAllSelected);
  // }, [selectedDate, isAllSelected]);

  // useEffect(() => {
  //   console.log("selecteddate", selectedDate);
  // }, [selectedDate]);

  const handleCheckboxChange = (date: string) => {
    setSelectedDate((prevDates: any) => {
      if (prevDates.includes(date)) {
        // Remove if already selected
        return prevDates.filter((d: any) => d !== date);
      } else {
        // Add if not selected
        return [...prevDates, date];
      }
    });
  };

  const handleSelectAllChange = () => {
  if (isAllSelected) {
    // Unselect all
    setSelectedDate([]);
  } else {
    // Select all
    setSelectedDate(allDates);
  }
};


  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);
    if (!remark.trim()) {
      showToast.warning("Please Fill Remark");
      setIsSubmitting(false);
      return;
    }

        if (remark.trim().length < 3) {
  showToast.warning("Remark must be at least 3 characters long");
  return;
}

    if (!DayLockedListDates?.data || !selectedDate?.length) {
      showToast.warning("No attendance date selected");
      setIsSubmitting(false);
      return;
    }
    const selectedAttendanceIds = DayLockedListDates?.data
      .filter((date: any) => selectedDate.includes(date.AttendanceDate))
      .map((date: any) => date.AttendanceId);

    const payload = {
      employeeId: selectedRow?.EmployeeId,
      attendanceId: selectedAttendanceIds,
      remark: remark,
      releaseType: "",
    };
    DayRelease(payload, {
      onSuccess: () => {
        if (isAllSelected) {
          queryClient.invalidateQueries({ queryKey: ["GET_DAY_LOCKED_LIST"] });
          toggle();
        } else {
          queryClient.invalidateQueries({ queryKey: ["GET_DAY_LOCKED_LIST"] });
          queryClient.invalidateQueries({
            queryKey: ["GET_DAY_LOCKED_DATE_BY_ID"],
          });

          toggle();
        }
      },
      onSettled: () => {
        // ✅ Reset after request finishes (success or fail)
        setIsSubmitting(false);
      },
    });
    // Add your submit logic here
  };

  

  return (
    <>
    {isLoading?(<div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>):(
    <form onSubmit={handleSubmit}>
      <label
        style={{ fontWeight: "500", marginBottom: "15px", fontSize: "20px" }}
      >
        Day Unlock
      </label>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          maxHeight: "300px", // or any height that suits your layout
          overflowY: "auto",
          paddingRight: "10px",
          scrollbarWidth:'thin' // for better scroll UX
        }}
      >
        {uniqueDayLockedDates.map((date: any) => (
          <label
            key={date}
            className="flex items-center space-x-2"
            style={{ gap: "5px", display: "flex", alignItems: "center" }}
          >
            <input
              type="checkbox"
              checked={selectedDate.includes(date.AttendanceDate)}
              onChange={() => handleCheckboxChange(date.AttendanceDate)}
            />
            <span>{date.AttendanceDate}</span>
          </label>
        ))}

        
      </div>
        <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          maxHeight: "300px", // or any height that suits your layout
          
          paddingRight: "10px", // for better scroll UX
        }}
      >
       <label
    className="flex items-center space-x-2"
    style={{ gap: "5px", display: "flex", alignItems: "center" }}
  >
    <input
      type="checkbox"
      checked={isAllSelected}
      onChange={handleSelectAllChange}
    />
    <span>Select All</span>
  </label>
  </div>
      <div>
        <div className="form-input position-relative">
          <CustomInput
          label="Remark"
            type={"text"}
            placeholder="Enter Remark"
            onChange={(event) => setRemark(event.target.value)}
            value={remark}
          />
        </div>
      </div>
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          type="submit"
          disabled={isSubmitting}
          style={{ backgroundColor: "#43B9B2", color: "white" }} // ✅ prevents multiple clicks
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={toggle}
        >
          Cancel
        </Btn>
      </div>
    </form>
        )
      }
      </>
  );
};

const DayLocked: React.FC = () => {
  const [filtersState, setFiltersState] = useState<any>({
    status: null,
    limit: 10,
    page: 1,
    search: null,
    gradeMaster: null,
    orgUnits: null,
    Position: null,
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<{ status: string } | null>(
    null
  );

  const [positionSearchTerm, setPositionSearchTerm] = useState("");
  const [positionPage, setPositionPage] = useState(1);
  const [positionHasMore, setPositionHasMore] = useState(true);
  const [positionOptions, setPositionOptions] = useState<any[]>([]);
  const [position,setPosition]=useState<any>('')
        const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
      const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
              const { startPolling, stopPolling } = useExcelPolling();
      

  const EmployeeListColumns = [
    {
      name: "Emp Code",
      selector: (row: { EmployeeCode: number | string }) =>
        row.EmployeeCode || "-",
      sortable: true,
      minWidth: "130px",
    },
     {
      name: "Emp Name",
      sortable: true,
      cell: (row: { FirstName: string,LastName:string }) =>
        (
          <Link
          to={`/employeeDetails`}
          state={{ employeeData: row }}
          style={{ textDecoration: "none", color: "blue" }}
        >
          {row.FirstName+' '+row.LastName || "-"}
        </Link>
        ) ,
      
      minWidth:'150px',wrap:true

    },
    {
      name: "HQ",
      selector: (row: { Stownname: string }) => row?.Stownname || "-", // (depend by backend)
      sortable: true,
      minWidth: "130px",
      wrap: true,
    },
    {
      name: "Org Unit",
      selector: (row: { UnitName: string }) => row?.UnitName || "-", // (depend by backend)
      sortable: true,
      minWidth: "130px",
      wrap: true,
    },
    {
      name: "Grade",
      selector: (row: { GradeName: string }) => row?.GradeName || "-",
      sortable: true,
      wrap: true,
      minWidth: "130px",
    },
    {
      name: "Position",
      selector: (row: { PositionName: string }) => row?.PositionName || "-",
      sortable: true,
      minWidth: "130px",
      wrap: true,
    },
    {
      name: "Phone no.",
      selector: (row: { Phone: string }) => row.Phone || "-", // need to add (depend by backend)
      sortable: true,
      minWidth: "120px",
      wrap: true,
    },
    {
      name: "Status",
      selector: (row: { Status: any }) =>
        employeeStatus?.["response"]?.[row.Status], // employeeStatus?.['response']?.[row.Status]
      sortable: true,
      wrap: true,
      minWidth: "130px",
    },
    {
      name: "Action",
      selector: (row: { status: string }) => row.status,
      cell: (row: { status: string }) => (
        <button
          onClick={() => {
            setIsModalOpen(true);
            setSelectedRow(row);
          }}
          className="btn btn-primary"
          style={{
            borderRadius: "15px",
            padding: "0px 10px",
            width: "fit-content",
            backgroundColor: "red",
            border: "none",
          }}
        >
          Day Locked
        </button>
      ),
      sortable: true,
      minWidth: "180px",
    },
  ];

//   const HeaderContent = () => {
//   const handleFilter = (key: any, selected: any) => {
//     setFiltersState((prev: any) => ({
//       ...prev,
//       [key]: selected.id === "null" ? null : Number(selected.id),
//     }));
//   };
//   return (
//     <div
//       style={{
//         marginBottom: "15px",
//         gap: "10px",
//         display: "flex",
//         justifyContent: "flex-end",
//       }}
//     >
//       <RoundedDropdown
//         options={orgUnitsList?.data || []}
//         onSelect={(e) => {
//           handleFilter("orgUnits", e);
//         }}
//         defaultLabel="All"
//         width="auto"
//         isShowHeading
//         DropdownHeading="Org Unit"
//         headingColor="#2e8dd3"
//       />

//       <RoundedDropdown
//         options={gradeMaster?.data || []}
//         onSelect={(e) => {
//           handleFilter("gradeMaster", e);
//         }}
//         defaultLabel="All"
//         width="auto"
//         isShowHeading
//         DropdownHeading="Grade"
//         headingColor="#2e8dd3"
//       />

//       <CustomDropdown
//         placeholder="All"
//         DropdownLabel="Position"
//         value={Position}
//         onChange={(id) => {
//           setPosition((prev: any) => ({
//             ...prev,
//             Position: id,
//             page: 1,
//           }));
//         }}
//         fetchData={async ({ page, limit, search }) => {
//           const res = await getAllPositionList({
//             page,
//             limit,
//             search,
//           });

//           const rawData = res?.data?.Positions || {};
//           console.log(rawData);
//           let formatted = rawData?.map((item: any) => ({
//             id: item.PositionId,
//             label: item.PositionName,
//           }));

//           // ✅ Add "All" only on the first page
//           if (page === 1) {
//             formatted = [{ id: "", label: "All" }, ...formatted];
//           }
//           const hasMore = Object.keys(rawData).length === limit;

//           return {
//             data: formatted,
//             hasMore,
//           };
//         }}
//         includeAllOption
//       />
//       {/* <RoundedDropdown
//         options={props?.PositionDropdownList|| []}
//         onSelect={(e) => {
//           handleFilter("Position", e);
//         }}
//         onSearch={(val) => props.onPositionSearch(val)}
//         defaultLabel="All"
//         width="auto"
//     onLoadMore={props.onPositionLoadMore}

//         isShowHeading
//         DropdownHeading="Position"
//         headingColor="#2e8dd3"
//       /> */}

//       <RoundedDropdown
//         options={employeeStatus?.data || []}
//         onSelect={(e) => {
//           handleFilter("status", e);
//         }}
//         defaultLabel="All"
//         width="auto"
//         isShowHeading
//         DropdownHeading="Status"
//         headingColor="#2e8dd3"
//       />
//     </div>
//   );
// };

  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
  const { data: gradeMaster } = useGetGradeMastersData({ enable: true });
  const { data: employeeStatus } = useGetEmployeeStatusData({ enable: true });
  const { data: designationsData } = useGetDesignationsData({ enable: true });

  const { data: DayLockedList, isLoading } = useDayLockedListData({
    params: {
      page: filtersState.page,
      limit: filtersState.limit,
      search: filtersState.search,
      status: filtersState.status,
      orgUnit: filtersState.orgUnits,
      grade: filtersState.gradeMaster,
      position: position.Position
    },
    enable: true,
  });

  const { data: PositionList } = useAllPositionList({
    params: {
      orgUnitId: filtersState?.orgUnits,
      // fetch:'all'
      page: positionPage,
      limit: 10,
      search: positionSearchTerm,
    },
    enabled: !!orgUnitsList,
  });

  useEffect(() => {
    const newItems = Object.entries(PositionList?.data?.Positions || {}).map(
      ([key, label]: any) => ({
        id: label.PositionId,
        label: label.PositionName,
      })
    );

    setPositionOptions((prev) => {
      // Combine previous and new, then deduplicate by `id`
      const combined = [...prev, ...newItems];

      // Create a map to remove duplicates (by id)
      const dedupedMap = new Map<string, { id: string; label: string }>();
      combined.forEach((item) => {
        dedupedMap.set(item.id, item);
      });

      // Convert back to array
      let deduped = Array.from(dedupedMap.values());

      // Ensure "All" is always the first option
      deduped = deduped.filter((item) => item.id !== "null");
      return [{ id: "null", label: "All" }, ...deduped];
    });

    if (newItems.length < 10) {
      setPositionHasMore(false);
    }
  }, [PositionList]);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

    const handleFilter = (key: any, selected: any) => {
    setFiltersState((prev: any) => ({
      ...prev,
      [key]: selected.id === "null" ? null : Number(selected.id),
    }));
  };


//   const handleExcel = async () => {
//   try {
//     const appToken = localStorage.getItem("Apptoken") || "";
//     const orgUnitId = filtersState.orgUnits || "";
//     const start = filtersState?.page || "";
//     const length = filtersState?.limit || "";
//     const search = filtersState?.search || "";
//       const Position = position.Position||"";
//     const grade=filtersState.gradeMaster||"";

//     const params = new URLSearchParams();

//     // Append only if the value exists
//     if (orgUnitId) params.append("orgUnit", orgUnitId);
//     if (Position) params.append("position", Position);
//     if (grade) params.append("grade", grade);
//     if (start) params.append("page", start);
//     if (length) params.append("limit", length);
//     if (search) params.append("search", search);

//     const response = await fetch(
//       `https://tspc-development.truesales.in/admin/api/getEmployeeListExcel?params=locked&${params.toString()}`,
//       {
//         method: "GET",
//         headers: {
//           accept: "application/json",
//           apptoken: appToken,
//         },
//       }
//     );

//     if (!response.ok) {
//       throw new Error("Failed to download Excel file");
//     }

//     const blob = await response.blob();
//     const url = window.URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "EmployeeDayLockedList.xlsx"; // custom filename
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     window.URL.revokeObjectURL(url);
//   } catch (error) {
//     console.error("Error downloading Excel file:", error);
//   }
// };


     const downloadExcelGet = async () => {
  const appToken = localStorage.getItem("Apptoken") || "";
   const orgUnitId = filtersState.orgUnits || "";
    const start = filtersState?.page || "";
    const length = filtersState?.limit || "";
    const search = filtersState?.search || "";
      const Position = position.Position||"";
    const grade=filtersState.gradeMaster||"";

    const params = new URLSearchParams();

    // Append only if the value exists
    if (orgUnitId) params.append("orgUnit", orgUnitId);
    if (position) params.append("position", Position);
    // if (classification) params.append("classification", classification);
    if (grade) params.append("grade", grade);
    if (start) params.append("start", start);
    if (length) params.append("limit", length);
    if (search) params.append("search", search);
     const queryString = params.toString();
      try {
        setLoadingExcel(true);
        const response = await axiosInstance.get(
          `${API_ENDPOINTS.EMPLOYEE.GET_EMPLOYEE_LIST_EXCEL}?params=locked&${queryString}`
        );
        console.log("responseresponseresponse",response)
        const { success, fileDownloadId, intervalTime } =
          response?.data?.data|| null;
  
        if (success && fileDownloadId) {
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: any) => {
              setLoadingExcel(false);
              setExcelStatus('Loading..');
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (msg: any) => showToast.error(msg || ""),
            onExpired: (msg: any) => showToast.error(msg || ""),
            onDeleted: (msg: any) =>{ showToast.error(msg || "");setLoadingExcel(false)},
          });
        }
      } catch (err: any) {
        showToast.error(err);
      }
    };
  return (
    <div className="p-2">
      <PageHeader title="Day Locked"
      buttons={[
          {
                        label: loadingExcel? excelStatus ? excelStatus.charAt(0).toUpperCase() + excelStatus.slice(1) +"..": "": "Excel",
                         onClick:downloadExcelGet,
                       color: loadingExcel ? COLORS.disable : COLORS.primary,
                                   disable: loadingExcel ? true : false,
                        },
      ]}
      
      />
      <div
        // className="container"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0px", // Spacing between the cards
          justifyContent: "space-between",
          // padding: "0px 20px 0px 20px",
          width: "100%",
        }}
      >
        <div
          style={{
            flex: "1",
            minWidth: "100%",
            maxWidth: "100%",
            paddingBottom: "20px",
          }}
        >
          <BasicDataTable
            paginationTotalRows={
              DayLockedList?.data?.Pagination?.TotalEmployees || 0
            }
            dynamicHeightOnRowsPerPage={true}
            showSpinner={isLoading}
            onChangePage={(pageNo: number) => {
              handlePagination(pageNo);
            }}
            onChangeRowsPerPage={(newPerPage: any, page: any) => {
              handleonChangeRowsPerPage(newPerPage, page);
            }}
            handleSearch={(val: any) => {
              handleSearch(val);
            }}
            Title="Employee"
            columns={EmployeeListColumns}
            data={DayLockedList?.data?.Employees}
            headerContent={
               <div
      style={{
        marginBottom: "15px",
        gap: "10px",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <RoundedDropdown
        options={orgUnitsList?.data || []}
        onSelect={(e) => {
          handleFilter("orgUnits", e);
        }}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading="Org Unit"
        headingColor="#2e8dd3"
      />

      <RoundedDropdown
        options={gradeMaster?.data || []}
        onSelect={(e) => {
          handleFilter("gradeMaster", e);
        }}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading="Grade"
        headingColor="#2e8dd3"
      />

      <CustomDropdown
        placeholder="All"
        DropdownLabel="Position"
        value={position}
        onChange={(id) => {
          setPosition((prev: any) => ({
            ...prev,
            Position: id,
            page: 1,
          }));


        }}
        fetchData={async ({ page, limit, search }) => {
          const res = await getAllPositionList({
            page,
            limit,
            search,
          });

          const rawData = res?.data?.Positions || {};
          console.log(rawData);
          let formatted = rawData?.map((item: any) => ({
            id: item.PositionId,
            label: item.PositionName,
          }));

          // ✅ Add "All" only on the first page
          if (page === 1) {
            formatted = [{ id: "", label: "All" }, ...formatted];
          }
          const hasMore = Object.keys(rawData).length === limit;

          return {
            data: formatted,
            hasMore,
          };
        }}
        includeAllOption
      />
      {/* <RoundedDropdown
        options={props?.PositionDropdownList|| []}
        onSelect={(e) => {
          handleFilter("Position", e);
        }}
        onSearch={(val) => props.onPositionSearch(val)}
        defaultLabel="All"
        width="auto"
    onLoadMore={props.onPositionLoadMore}

        isShowHeading
        DropdownHeading="Position"
        headingColor="#2e8dd3"
      /> */}

      <RoundedDropdown
        options={employeeStatus?.data || []}
        onSelect={(e) => {
          handleFilter("status", e);
        }}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading="Status"
        headingColor="#2e8dd3"
      />
    </div>
            }
          />
        </div>
      </div>
      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        // title={"Edit Profile"}
        size="sm"
        content={
          <DayLockedModal selectedRow={selectedRow} toggle={toggleModal} />
        }
      />
    </div>
  );
};

export default DayLocked;
